import React from 'react';
import { Select } from 'antd';
import { connect } from 'react-redux';

import { pageListLoad } from "store/models/page";
import { FormItem } from "utils";
import { ListLoadComponent } from 'components/common';


const PageSelect = (props) => {
  return (
    <ListLoadComponent
      apiLoad={pageListLoad}
      {...props}
      render={({ items }) => {
        const { onChange, disabled, router, authToken, model, dispatch, ...otherProps } = props;
        return (
          <FormItem {...otherProps}>
            <Select
              style={{ width: '100%' }}
              onChange={onChange}
              showSearch={true}
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option.props.children;
                return children.join("").toLowerCase().indexOf(input.toLowerCase()) >= 0
              }}
              disabled={disabled}
            >
              {!props.required && <Select.Option value={null}>---</Select.Option>}
              {items.map(item => (
                <Select.Option key={`page${item.id}`} value={item.id}>
                  {item.title} {item.path}
                </Select.Option>
              ))}
            </Select>
          </FormItem>
        );
      }}
    />
  );
};

const mapState = state => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.page,
});

export default connect(mapState)(PageSelect);
